const SubjectNameUtil = {

  initialize(router) {
    SubjectNameUtil.$routeNameMap = {};
    SubjectNameUtil.$routePathMap = {};
    SubjectNameUtil.$subjectMetaMap = {};
    SubjectNameUtil.$routes = router.options.routes;

    const routeTree = router.options.routes;
    this.each(routeTree, item => {
      if (item.name) SubjectNameUtil.$routeNameMap[item.name] = item;
      if (item.path) SubjectNameUtil.$routePathMap[item.path] = item;
    });

    let children = this.findByPath('/subject')?.children;
    children = children ? children : [];

    children.forEach(item => {
      if (item.meta) SubjectNameUtil.$subjectMetaMap[item.name] = item.meta;
    });

  },

  findByName(name) {
    return SubjectNameUtil.$routeNameMap[name];
  },

  findByPath(path) {
    return SubjectNameUtil.$routePathMap[path];
  },

  each(list, callback) {
    const array = Array.from(list);
    array.forEach(item => {
      callback(item);

      if (item.hasOwnProperty('children')) {
        this.each(item.children, callback);
      }
    });
  },

  /**
   * 메뉴이름으로 주제별 path 정보 가져오기
   *
   * @example getSubjectPathByName('문화')
   * @param name 이름
   * @returns {string}
   */
  getSubjectPathByName: function (name) {
    const meta = SubjectNameUtil.$subjectMetaMap[name];
    if (meta && meta.subjectId) {
      return meta.subjectId;
    } else {
      console.warn(`can not found subject path, name: ${name}`);
      return '';
    }
  },

  /**
   * 통계표 아이디로 명칭 가져오기
   *
   * @param subjectId STBL-1014250
   * @returns 문화
   */
  getSubjectNameById: function (subjectId) {
    const name = Object.entries(SubjectNameUtil.$subjectMetaMap).filter(entry => {
      return entry[1].subMenuItemMgmNo === subjectId;
    }).map(entry => entry[0]).at(0);

    if (!name) {
      console.warn(`can not found subject id, ${subjectId}`);
      return '';
    }

    return name;
  },

  /**
   * 메뉴 Path로 주제별 path 정보 가져오기
   *
   * @example getSubjectPathByUpPath('문화>>국민여가활동조사')
   * @param path 메뉴 Path
   * @returns {string}
   */
  getSubjectPathByUpPath: function (path) {
    const paths = path.split('>>');
    if (paths.length)
      return this.getSubjectPathByName(paths[0]);

    console.warn(`path is wrong., path: ${path}`);
    return ''
  }
}

export default SubjectNameUtil
